import { useTranslation } from "react-i18next";

const StepCard = (props: {
    key: string;
    illustration: string;
    stepNumber: number;
    title: string;
    paragraph: string;
}) => {
    const { t } = useTranslation();

    return (
        <div className="steps">
            <img
                alt={props.title}
                className="steps__illustration"
                src={props.illustration}
            />
            <div className="steps__content">
                <h4 className="mb-2">{t("step")}{props.stepNumber}</h4>
                <h3 className="mb-3">{props.title}</h3>
                <p>{props.paragraph}</p>
            </div>
        </div>
    );
};

export default StepCard;
